import styled from '@emotion/styled';
import { SingleSelect } from 'src/web/components/Input/DropdownsOld/SingleSelect';
import { OL_COLOUR_BLACK_55_HEX } from '../../../../../components/Style/colours';

export const StyledSingleSelect = styled(SingleSelect)({
  flexGrow: 1,
  '> .react-selectize.root-node': {
    width: '100%',
  },
});

export const FilterByUserSelect = styled(StyledSingleSelect)({
  flexBasis: 300,
});

export const InstitutionRoleSelect = styled(StyledSingleSelect)({
  flexBasis: 200,
});

export const CourseAssignedSelect = styled(StyledSingleSelect)({
  flexBasis: 300,
});

export const GroupName = styled('div')({
  ':not(:last-child)': {
    marginBottom: 20,
  },
});

export const TableHeading = styled('div')(
  ({ minWidth }: { minWidth?: number }) => ({
    whiteSpace: 'nowrap',
    minWidth: minWidth ?? 'auto',
  })
);

export const UserEmail = styled('div')({
  color: OL_COLOUR_BLACK_55_HEX,
  fontWeight: 400,
});
